module.exports = {"id":"200429","name":"Benito Raman","rating":"73","photo":"./data/images/photos/4/200429.png","club":{"name":"F. Düsseldorf","logo":"./data/images/clubs/F.Dusseldorf.png"},"positions":["MG","MD","BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BenitoRaman0.json
// module id = 564
// module chunks = 0